// extracted by mini-css-extract-plugin
export default {"development":"city-development_development__VzqLO","development_left":"city-development_development_left__0FW2P","development_right":"city-development_development_right__Acm1I"};